// extracted by mini-css-extract-plugin
export var illustration = "job-karriere-module--illustration--YFWEw";
export var spinAround = "job-karriere-module--spinAround--eWOZ9";